import {useSelector} from 'react-redux';

export default () => useSelector(({reconciliations}) => reconciliations.selected.componentRisks);
